import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'rx-patient-avatar',
	standalone: true,
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<img *ngIf="thumbnailUrl" [src]="thumbnailUrl" (error)="onError()" class="avatar-img" [attr.alt]="firstName + ' ' + lastName" />
		<span *ngIf="!thumbnailUrl" class="initials">{{ firstName.charAt(0) }}{{ lastName.charAt(0) }}</span>
	`,
	styles: [`
		:host {
			display: block;
			border-radius: 50%;
			background: var(--tlk-gray-30);
			overflow: hidden;
			flex-shrink: 0;
			line-height: 0;
		}
		.avatar-img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}
		.initials {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
			font: var(--tlk-text-label-font--small);
			font-weight: 600;
			color: var(--tlk-blue-80);
			text-transform: uppercase;
			user-select: none;
		}
	`],
	host: {
		'[style.width.px]': 'size',
		'[style.height.px]': 'size'
	}
})
export class PatientAvatarComponent {
	@Input() firstName = '';
	@Input() lastName = '';
	@Input() thumbnailUrl: string | null = null;
	@Input() size = 40;

	onError(): void {
		this.thumbnailUrl = null;
	}
}
